'use client';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { styled } from '@mui/material/styles';

export const SwipeableDrawerComponent = styled(SwipeableDrawer)();
